import {
  CognitoAuth
} from 'amazon-cognito-auth-js';
import router from '@/router';

/*
  Initialise auth
*/
const auth = new CognitoAuth({
  ClientId: `${process.env.COGNITO_CLIENT_ID}`,
  AppWebDomain: `${process.env.COGNITO_WEB_DOMAIN}`,
  IdentifyProvider: `${process.env.COGNITO_IEDNTITY_PROVIDER}`,
  TokenScopesArray: JSON.parse(`${process.env.COGNITO_TOKEN_SCOPES}`),
  RedirectUriSignIn: `${process.env.COGNITO_SIGN_IN_URI}`,
  RedirectUriSignOut: `${process.env.COGNITO_SIGN_OUT_URI}`,
  UserPoolId: `${process.env.COGNITO_USER_POOL_ID}`
});

auth.userhandler = {
  onSuccess: function (result) {
    // Clear address bar params
    router.replace({
      'query': null
    });
  },
  onFailure: function (err) {
    console.log("Error:", err);
  }
};

auth.useCodeGrantFlow();

/*
  Get user object
*/
const getUser = () => auth.getSignInUserSession().idToken.payload;

/*
  Check users role for use in routes and UI
*/
const hasRole = (roles) => {
  const user = getUser();
  const userRole = user['cognito:groups'] ? user['cognito:groups'][0].toLowerCase() : null;
  let allowed = false;

  if (!user) {
    return false;
  }

  // If user doesn't belong to a group
  if (!userRole) return false;

  // Loop through allowed roles and check for a match
  roles.some(function (el) {
    if (el === userRole) {
      allowed = true;
    }
  })

  if (allowed) {
    return true;
  } else {
    return false;
  }
}

export {
  auth,
  getUser,
  hasRole
};


// WEBPACK FOOTER //
// ./src/middleware/auth.js